/**
 * whatsapp-tracking.js
 * Single delegated click listener that emits a `whatsapp_click` event
 * for any anchor flagged with [data-whatsapp]. Pushes to window.dataLayer
 * and (if present) gtag — both are no-ops if absent.
 *
 * This is purely additive — the existing data-cta-track system continues
 * to fire its own analytics hook independently.
 */
(function () {
  'use strict';

  function pushClick(target) {
    var locale = (document.documentElement && document.documentElement.lang) || null;
    var payload = {
      event: 'whatsapp_click',
      location: target.dataset.location || null,
      product_id: target.dataset.productId || null,
      variant_id: target.dataset.variantId || null,
      locale: locale
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    if (typeof window.gtag === 'function') {
      try {
        window.gtag('event', 'whatsapp_click', {
          location: payload.location,
          product_id: payload.product_id,
          variant_id: payload.variant_id,
          locale: payload.locale
        });
      } catch (e) {
        // swallow — analytics failures must not block the click
      }
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      var anchor = target.closest('a[data-whatsapp]');
      if (!anchor) return;
      pushClick(anchor);
    },
    true // capture phase — fire even if a downstream handler stopPropagates
  );
})();
